export const RESERVATION_CONST = {
    GET_VISIT_DATA:"GET_VISIT_DATA",
    DELETE_VISIT_DATA:"DELETE_VISIT_DATA",
}